<template>
  <div class='img-captcha' v-show='show'>
    <div class="mask"></div>
    <div class='captcha-box'>
      <div class='captcha-hd'>
        <h2>请输入验证码</h2>
      </div>
      <div class='captcha-md'>
        <input v-model="currentValue" class='input' type="text" :placeholder="placeholder" @blur='blur' @focus='focus' :maxlength='length'>
        <span class="error-text" v-show='error'>{{error}}</span>
        <div class='img-wrap' @click='refreshImgCaptcha'>
          <img :src="imgBaseStr" alt="img">
          <i class="iconfont">&#xe69c;</i>
        </div>
      </div>
      <div class='captcha-bd'>
        <button class='btn-cancel' @click="cancel">取消</button>
        <button class='btn-primary' @click="submit">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '../../service/user'
import validateMethods from '../../utils/validate'
import utils from '../../utils'

export default {
  name: 'img-captcha',
  data () {
    return {
      currentValue: '',
      error: '',
      imgData: ''
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    requestUrl: {
      type: String,
      default: ''
    },
    errorMsg: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '输入图形验证码'
    },
    length: {
      type: Number,
      default: 4
    }
  },
  computed: {
    imgBaseStr () {
      return `data:image/png;base64,${this.imgData}`
    },
    checkUrl () {
      let url = ''
      // if (this.requestUrl) {
      //   url = this.requestUrl.replace('captcha', 'check')
      // }
      url = '/serv/tgo/common/check-captcha'
      return url
    }
  },
  methods: {
    blur () {
      this.$emit('blur')
      if (!validateMethods.checkEmpty(this.currentValue)) {
        this.error = '请输入图形验证码'
        return
      }
      if (!validateMethods.checkImgCaptcha(this.currentValue)) {
        this.error = '图形验证码格式错误'
      }
    },
    focus () {
      this.error = ''
      this.$emit('focus')
    },
    submit () {
      if (this.currentValue.length !== 4) {
        return
      }
      UserService.request(this.checkUrl, { captcha_code: this.currentValue }).then(res => {
        this.$emit('captcha', this.currentValue)
      }).catch(err => {
        if (err && err.error && err.error.code) {
          let code = String(err.error.code)
          if (code === '-9108') {
            this.refreshImgCaptcha()
          }
        }
        this.error = utils.parseError(err)
      })
    },
    cancel () {
      this.$emit('cancel')
    },
    refreshImgCaptcha () {
      this.currentValue = ''
      UserService.getImgCaptcha(this.requestUrl).then(res => {
        this.imgData = res.data
      }).catch(() => {
        this.error = '获取图片验证码失败，请重试'
      })
    }
  },
  watch: {
    show (newVal) {
      if (newVal) {
        this.refreshImgCaptcha()
      }
    },
    errorMsg (newVal) {
      this.error = newVal
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../../assets/css/common';
@import "../../assets/css/button";
@import "../../assets/css/input";

.img-captcha{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .captcha-box{
    width: 90%;
    min-height: 10rem;
    border-radius: 6px;
    background: #fff;
    z-index: 1;
    max-width: 450px;
    .captcha-hd{
      text-align: center;
      border-bottom: #f4f4f4 solid 1px;
      h2{
        font-size: 22px;
        line-height: 6rem;
      }
    }
    .captcha-md{
      position: relative;
      margin: 1.875rem 2rem 1.2rem;
      .img-wrap{
        position: absolute;
        right: 1px;
        top: 2px;
        cursor: pointer;
        img{
          display: block;
          height: 35px;
          width: auto;
        }
        i{
          position: absolute;
          font-size: 1.25rem;
          right: 0;
          bottom: 0;
          line-height: 1;
          padding-top: 15px;
          background-color: $gray-lighter;
        }
      }
    }
    .captcha-bd{
      padding: 0 2rem;
      margin-bottom: 2.125rem;
      display: flex;
      justify-content: center;
      button{
        &:first-child{
          margin-right: 1rem;
        }
      }
    }
  }
}
</style>
